import React, { useState, useEffect } from 'react';

const Toast = ({ message, type = 'error', onClose, duration = 3000 }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        // Auto close after duration
        const timer = setTimeout(() => {
            handleClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration]);

    const handleClose = () => {
        setIsExiting(true);
        setTimeout(() => {
            setIsVisible(false);
            if (onClose) {
                onClose();
            }
        }, 300); // Animation duration
    };

    if (!isVisible) {
        return null;
    }

    const getToastStyles = () => {
        const baseStyles = {
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 9999,
            padding: '12px 16px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            minWidth: '300px',
            maxWidth: '500px',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'all 0.3s ease-in-out',
            transform: isExiting ? 'translateX(100%)' : 'translateX(0)',
            opacity: isExiting ? 0 : 1,
        };

        const typeStyles = {
            error: {
                backgroundColor: '#fee2e2',
                borderLeft: '4px solid #dc2626',
                color: '#991b1b',
            },
            success: {
                backgroundColor: '#d1fae5',
                borderLeft: '4px solid #059669',
                color: '#047857',
            },
            warning: {
                backgroundColor: '#fef3cd',
                borderLeft: '4px solid #d97706',
                color: '#92400e',
            },
            info: {
                backgroundColor: '#dbeafe',
                borderLeft: '4px solid #2563eb',
                color: '#1d4ed8',
            },
        };

        return { ...baseStyles, ...typeStyles[type] };
    };

    const getIcon = () => {
        const iconStyles = {
            marginRight: '8px',
            fontSize: '16px',
        };

        switch (type) {
            case 'success':
                return <span style={iconStyles}>✓</span>;
            case 'warning':
                return <span style={iconStyles}>⚠</span>;
            case 'info':
                return <span style={iconStyles}>ℹ</span>;
            case 'error':
            default:
                return <span style={iconStyles}>✕</span>;
        }
    };

    return (
        <div style={getToastStyles()}>
            <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                {getIcon()}
                <span>{message}</span>
            </div>
            <button
                onClick={handleClose}
                style={{
                    background: 'none',
                    border: 'none',
                    color: 'inherit',
                    fontSize: '18px',
                    cursor: 'pointer',
                    marginLeft: '12px',
                    padding: '0',
                    lineHeight: 1,
                    opacity: 0.7,
                    transition: 'opacity 0.2s ease',
                }}
                onMouseEnter={(e) => e.target.style.opacity = 1}
                onMouseLeave={(e) => e.target.style.opacity = 0.7}
                title="Close"
            >
                ×
            </button>
        </div>
    );
};

export default Toast;
